import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Accordion, Card } from 'react-bootstrap'
import classNames from 'classnames'

import CampaignHeader, { tcLabelOptions } from 'components/Recommendations/Campaign/CampaignHeader'
import { isCampaignOpen } from 'api/models'
import { useTranslation } from 'react-i18next'

function getCampaignTcLabelStatus(campaign, selectedTcs, totalSelectableTcs) {
    if (isCampaignOpen(campaign)) {
        if (selectedTcs.some(tc => tc === campaign.tc))
            return tcLabelOptions.selected
        else if (selectedTcs.length < totalSelectableTcs)
            return tcLabelOptions.select
    }
    return tcLabelOptions.selectDisabled
}

const OpenCampaigns = ({ campaigns = [], selectedTcs = [], setSelectedTcs = () => {}, totalUniqueTcs, isCampaignSetupInProgress }) => {
    const { t } = useTranslation()
    const [availableTcsOpen, setAvailableTcsOpen] = useState(false)

    const toggleTcSelection = useCallback((campaign) => {
        if (selectedTcs.some(tc => tc === campaign.tc))
            setSelectedTcs(selectedTcs.filter(x => x !== campaign.tc))
        else if (selectedTcs.length < totalUniqueTcs)
            setSelectedTcs([...selectedTcs, campaign.tc])
    }, [setSelectedTcs, selectedTcs, totalUniqueTcs])

    const displayAvailableTasteClusters = () => {
        return campaigns.map((campaign) => {
            return  <CampaignHeader
                key={`${campaign.tc}/${campaign.tc_run_id}`}
                campaign={campaign}
                headerStatus={getCampaignTcLabelStatus(campaign, selectedTcs, totalUniqueTcs)}
                onTcLabelClick={() => toggleTcSelection(campaign)}
                className='p-0'
                isCampaignSetupInProgress={isCampaignSetupInProgress}
            />
        })
    }

    return <Accordion defaultActiveKey={null}>
        <Card className='m-0'>
            <Accordion.Toggle eventKey='0'>
                <Card.Header
                    as={Card.Header}
                    onClick={() => setAvailableTcsOpen(prev => !prev)}
                    className={classNames({
                        'pt-3': true,
                        'open': availableTcsOpen
                    })}
                >
                    <div className='campaign-header_toggle__title'>
                        {t('Recommendations.AvailableTasteClusters')}
                        <div className='align-self-center ml-auto'>
                            <div className={`accordion-arrow ${availableTcsOpen ? 'open' : ''}`} />
                        </div>
                    </div>
                </Card.Header>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey='0'>
                <Card.Body className='d-flex flex-column gap-3 p-3'>
                    {displayAvailableTasteClusters()}
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    </Accordion>
}

OpenCampaigns.propTypes = {
    campaigns: PropTypes.arrayOf(Object),
    selectedTcs: PropTypes.array,
    setSelectedTcs: PropTypes.func,
    totalUniqueTcs: PropTypes.number,
    isCampaignSetupInProgress: PropTypes.bool
}

export default OpenCampaigns